module.exports = __webpack_public_path__ + "img/album21_09.70f3a810.jpg";